import styled from "styled-components";

export const StudentManagementCss = styled.div`
    width: 100%;

    /** Box **/
    .box{
        /* width: 100%; */
        display: flex;
        align-items: flex-start;
        background-color: #fff;
        margin-top: 25px;
        flex-direction: row;
        padding: 10px 0 20px 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);


    }

    .centered {
        flex-direction: column;
        align-items: center;
    }

    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 100px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** Personal**/
    .changePhoto{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        /* width: 100%; */
        margin: 40px 85px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin-bottom: 10px;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }

            span{
                display: flex;
                align-items: center;
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }

    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: 40px 100px 0 0;

        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }

        span.invalid {
            font-size: 10px;
            margin-left: 5px;
            /* color: red; */
        }
        select{
            width: 220px;
            height: 35px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand',sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }


        .profile{
            display: flex;
            justify-content: flex-start;
            /* width: 100%; */
            /* max-width: 59%; */

            /* select{
                width: 220px;
                &:last-child{
                    display: none;
                }
            } */

            /* .role{
                width: 100%;
                max-width: 34%;
            } */

            .active{
                background-color: #00D36A;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
            }
        }

        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding-left: 10px;
            margin-bottom: 15px;
            background-color: transparent;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }

        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #87868F;
        }

        .addInput{
            width: 128px;
            height: 32px;
            border-radius: 26px;
            margin: 0 24px;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #87868F;
            cursor: pointer;
            font-family: 'Work Sans', sans-serif;
        }

        input:invalid{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            /* border: 1px solid red; */
            padding-left: 10px;
            margin-bottom: 15px;
        }

        .timezoneCard{
                div:nth-child(2){
                  width: 480px !important;

                  input{
                    width: 100% !important;
                  }
                  ul{
                    width: 480px !important;
                    li{
                      width: 100% !important;
                      button{
                        width: 100% !important;
                      }
                    }
                  }
                }
              }

        .inputs{
            display: flex;
            align-items: center;
            gap:12px;


        .lineInputs{
            .gender{
                width: 243px;
            }

            .MuiInput-input-14 {
                width: 215px;
                border: none;
                height: 19px;
                margin: 0;
            }

            .MuiFormControl-root-30 {
                border: 1px solid;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
            }

            input{
                width: 220px;
            }

            select.userPhoneTypeId{
                width: 300px;
            }

        }

        p{
            font-size: 11px;
            color: #87868F;
            margin-top: 22px;
        }

    }


        .telephone{
            input{
                width: 220px;
            }
        }


        button.password{
          width: auto;
                padding: 8px 12px;
            border-radius: 26px;
            margin-left: 0;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            cursor: pointer;
            font-weight: 100;
            margin: 2px 0 44px 0;
        }

        .notification{
            display: flex;

            .switch__container{
                margin: 5px 0 0 23px;

                span{
                    margin-left: 47px;
                    font-size: 12px;
                    color: #707070;
                    font-family: 'Quicksand', sans-serif;
                }
            }

            span.delete{
                margin: 11px 0 0 0;
                width: 55px;
                font-weight: bold;
            }
        }

        .switchBox{
            display: flex;

            .labelNotify{
              display: flex;
              flex-direction: column;
              width: auto;

              .doubleClick{
                color: #ccc !important;
              }
            }
        }

        .selects{
            display: flex;
            flex-direction: row;

        }

        .lineSelect{
            margin: 0 25px 0 0;

            p{
                font-size: 11px;
                margin-top: 22px;
                color: #403F4C;
            }
        }

        span.delete {
            color: red;
            font-size: 10px;
            font-weight: bold;
            margin-top: 30px;
            float: left;
        }



        button.jsx-4179805763    {
            width: 226px !important;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 0;
            margin-top: 0;
        }

        button.jsx-4179805763  {
            margin: 0 0 1px 0 !important;
            background: #B2B2B7;
            border-radius: 0;
        }
        button.focus.jsx-4179805763  {
            background: #B2B2B7;
        }
    }

    /** Button Save **/
    .buttonSave{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;
            font-family: 'Quicksand', sans-serif;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 475px;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 15px !important;
    }

    /** Plans **/
    .planBox{

        .box {
            flex-direction: column;
            padding: 0;

            .buttons{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                margin: 25px 35px 25px 0;
                padding: 0 15px 0 15px;
                cursor: pointer;

                button {
                    background-color: transparent;
                    border: 1px solid #787780;
                    color: #403F4C;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 71px;
                    height: 38px;
                    margin-top: 8px;
                    cursor: pointer;

                    &:last-child{
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        padding: 10px 20px;
                        height: 38px;
                        margin-top: 5px;
                        margin-left: 15px;
                        cursor: pointer;
                    }
                }
            }
        }

        .newPlan {
            width: 96% !important;
            display: flex;;
            align-items: center;
            justify-content: space-between;

            margin: 15px !important;

            .plans {
                margin: 0 !important;
            }
        }

        .PlansBox {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: space-between;
            flex-wrap: wrap;

            &:last-child{
                margin-bottom: 25px;
            }

            .chosenPlan {
                flex-direction: row;
                display: flex;
                margin: 0;
                width: 100%;
                height: 80px;
                padding: 10px 0 0 15px;
                margin-left: 13px;
                flex-wrap: wrap;

            h2 {
                    padding: 0 30px 0 0;
                    font-size: 15px;
                    color: #403F4C;
                    font-weight: bold;
                    margin: 0;
                }

                h3 {
                    padding: 0;
                    margin: 0;
                    font-size: 18px;
                    color: #403F4C;
                    font-weight: bold;
                }

                p {
                    color: #403F4C;
                    font-size: 15px;
                    padding: 0;
                    margin: 0 0 5px 0;
                }

                button {
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 86px;
                    height: 28px;
                    margin-top: 5px;
                    cursor: pointer;

                    &:last-child {
                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #B2B2B7;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 93px;
                        height: 28px;
                        margin: 5px 0 26px 10px;
                        cursor: pointer;
                    }
                }

            }

            .last {
                margin-bottom: 20px;
            }

            .detalhesBTN {
                flex-direction: column;

                .extrasClasses{
                    margin-top: 6px;
                }
            }

            .plans {
                display: flex;
                margin: 20px 85px 0 20px;

                .changePlan {
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    padding-left: 10px;

                    h2 {
                        color: #403F4C;
                        font-size: 18px;
                        font-weight: bold;
                        margin-top: 6px;
                    }

                    button {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 86px;
                        height: 22px;
                        margin-top: 5px;
                        cursor: pointer;
                        font-family: 'Quicksand', sans-serif;

                        &:last-child {
                            background-color: #fff;
                            border: 1px solid #B2B2B7;
                            color: #B2B2B7;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 93px;
                            height: 22px;
                            margin-top: 5px;
                            cursor: pointer;
                        }

                        .fa{
                            margin-left: 10px;
                        }
                    }
                }

                /** Controle Plano **/
                .controlPlan{
                    display: flex;
                    flex-direction: row;
                    align-items: start;
                    width: 100%;

                    .infos{
                        flex-direction: column;
                        margin: 8px 25px 0 0;
                    }

                    h2{
                        font-size: 13px;
                        color: #9E9EA4;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand', sans-serif;
                    }

                    h3{
                        font-size: 14px;
                        color: #403F4C;
                        margin: 3px 0 0 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        font-weight: 100;
                    }

                    span{
                        color: #004FFF;
                        font-size: 22px;
                        font-weight: bold;

                        &:last-child{
                            color: #004FFF;
                            font-size: 14px;
                            font-weight: 50
                        }
                    }
                }

                /** Números **/
                .numbers{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: -3px;
                }

                /** Stock **/
                .stock{
                    hr {
                        height: 4px;
                        background-color: #004FFF;
                        width: 100%;
                        border: none;
                        margin: 9px 0 10px 0;
                        opacity: 1;
                    }

                    span{
                        color: #004FFF;
                        font-size: 12px;
                    }
                }


                /** Pagamento **/
                .payment{
                    flex-direction: column;
                    margin-top: 7px;
                    width: 150px;

                    h2{
                        font-size: 14px;
                        color: #9E9EA4;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        text-transform: uppercase;
                        padding-bottom: 5px;
                    }

                    h3{
                        font-size: 16px;
                        color: #403F4C ;
                        margin: 0;
                        padding: 0;
                        font-family: 'Quicksand',sans-serif;
                        font-weight: 100;
                        display: flex;
                        align-items: center;

                        img{
                            margin-right: 8px;
                            width: 30px !important;
                            height: 20px !important;
                        }
                    }

                    button{
                        background-color: transparent;
                        border: 1px solid #FF5666;
                        color: #FF5666;
                        font-size: 11px;
                        border-radius: 26px;
                        width: auto;
                        height: 22px;
                        margin-top: 8px;
                        padding: 0 12px 0 12px;
                        cursor: pointer;
                    }

                    select {
                        width: 100%;
                        height: 38px;
                        border-radius: 26px;
                        border: 1px solid #403F4C;
                        padding-left: 10px;
                        margin-bottom: 15px;
                        color: #403F4C;
                        margin-right: 10px;
                        opacity: 0.4;
                    }
                }



                /** Valores **/
                .value {
                    margin-top: 8px;

                    h2{
                        font-size: 15px;
                        color: #87868F;
                        font-weight: bold;
                        margin: 0;
                        padding: 0;
                    }

                    h3{
                        font-size: 18px;
                        color: #403F4C;
                        font-weight: normal;
                        margin-top: 4px;
                        margin: 0;
                        padding: 0;
                    }

                    button{
                        background-color: #fff;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 94px;
                        height: 22px;
                        margin-top: 8px;
                        cursor: pointer;
                    }

                }

                &:nth-child(2) {
                    flex-direction: column;
                }

                &:last-child button{

                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #787881;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 104px;
                    height: 22px;
                    margin-top: 5px;
                    cursor: pointer;
                    font-family: 'Quicksand', sans-serif;

                    .fa{
                        margin-left: 7px;
                    }
                }

                .buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 25px;
                    padding: 0 15px 0 15px;
                    cursor: pointer;

                    button{
                        background-color: transparent;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 71px;
                        height: 38px;
                        margin-top: 8px;
                        cursor: pointer;

                        &:last-child{
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            padding: 10px 20px;
                            height: 38px;
                            margin-top: 5px;
                            cursor: pointer;
                        }
                    }

                    .cancel{
                        button{
                            background-color: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 104px;
                            height: 22px;
                            margin-top: 5px;
                            cursor: pointer;
                        }
                    }
                }

            }

            .planCancel{
                    color: #FF5666;
                    padding: 4px 10px 0 10px;
                    height: 23px;
                    margin-top: 32px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: 'Quicksand', sans-serif;
                }
        }
    }

    /** box Big **/
    .boxBig {
        width: 100%;
        padding: 10px 20px 0 0;
        margin: 0 auto;


        button {
            background-color: #fff;
            border: 1px solid #403F4C;
            color: #403F4C;
            font-size: 13px;
            border-radius: 26px;
            width: auto;
            height: 28px;
            margin-top: 0;
            cursor: pointer;
            padding: 0 12px 0 12px;
            float: right;
            display: block;
            font-family: 'Work Sans',sans-serif;
        }

        button.active {
            background-color: #004FFF;
            color: #fff;
            border: #004FFF;
            height: 32px;
            font-weight: 900;
            font-family: 'Work Sans', sans-serif;
            padding: 0 25px 0 25px;
        }

        .buttons{
            display: flex;
            justify-content: flex-end;
            font-family: 'Quicksand', sans-serif;
            align-items: center;
        }

        .itemBox {
            display: flex;
            justify-content: space-between;
            width: 100%;
            flex-wrap: nowrap;
            flex-direction: row;
            margin: 0 0 27px 0;
            align-items: normal;

            &:first-child {
                border-bottom: 1px solid #D9D8DB;
            }

            .buttonLast{
                margin: 28px 0 0 0;
                width: 135px;


            }

            h5{
                padding: 0;
                margin: 0 0 10px 0;
                font-weight: 100;
                color: #403F4C;
                font-size: 14px;

                /* &:last-child{
                    margin: 15px 0 7px 0 !important;
                } */
            }

            span{
                color: #004FFF;
                font-weight: 500;

                strong{
                    font-weight: bold;
                }
            }


            input{
                width: 90%;
                height: 29px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                background-color: transparent;
                font-family: 'Quicksand',sans-serif;
                font-size: 14px;
            }

            select{
                width: auto;
                height: 34px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding: 0 25px 0 25px;
                margin-bottom: 15px;
                color: #403F4C;
                opacity: 0.4;
            }

            .levelTop {
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                width: 100%;
                max-width: 260px;

                .levelTopLinguage {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .boxLanguage {
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        flex-direction: column;

                        h5{
                            padding: 0;
                            margin: 0;
                            color: #9F9FA5;
                            font-size: 15px;
                            font-weight: bold;
                        }

                        .language {
                            display: flex;
                            margin: 0 0 13px 0;
                            align-items: center;

                            img {
                                margin: 0 8px 0 0;
                                width: 30px !important;
                                height: 20px !important;
                            }

                            h5{
                                font-size: 16px;
                                color: #403F4C;
                                margin: 0;
                                padding: 0;
                                font-family: 'Quicksand',sans-serif;
                                font-weight: 100;
                            }
                        }


                    }

                    .boxLevel {
                        display: flex;
                        align-items: end;
                        align-content: flex-end;
                        flex-direction: column;
                        width: 100%;
                        text-align: left;
                        margin-left: 36px;


                        h5{
                            font-size: 15px;
                            color: #403F4C;
                            margin: 0 0 8px 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;

                            &:first-child{
                                font-weight: bold;
                                color: #9F9FA5;
                            }
                        }
                    }

                }

                .columLevel {
                    justify-content: flex-end;
                    display: flex;
                    width: 100%;

                    h5 {
                        text-align: right;
                        padding: 0;
                        margin: 0;
                        color: #87868F;
                    }

                }
            }



            .grades {
                display: flex;
                flex-direction: row;
                width: 139px;

                h6 {
                    margin: 28px 10px 0 0;
                    color: #9F9FA5;
                    font-size: 15px;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: bold;
                    width: 70px;
                }

                h5{
                    padding: 0;
                    margin: 0 0 10px 0;
                    color: #403F4C;
                    font-size: 14px;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: normal;

                    span {
                        color: #004FFF;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    /** Notifications **/
    .infoNotification {
        width: 100%;

        h2 {
            color: #403F4C;
            font-size: 18px;
            margin: 40px 0 0 52px;
            font-weight: 100;
            font-family: 'Quicksand', sans-serif;
        }

        ul {
            margin: 40px 0 0 57px;
            display: flex;
            width: 88%;
            flex-direction: column;

        li {
                display: flex;
                align-items: center;
                padding: 0;
                margin: 0;
                height: 50px;

                span {
                    width: 70px;
                    color: #403F4C;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif;
                }

            }
        }
    }

    /** Manage Available Hours **/
    .topManage {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        margin: 15px 25px 0 0;
        align-items: center;

        h2 {
            font-size: 18px;
            color: #403F4C;
            font-weight: normal;
        }

        button {
            background-color: #004FFF;
            border: none;
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            border-radius: 26px;
            width: auto;
            height: 38px;
            margin-top: 5px;
            padding: 12px;
            cursor: pointer;
            font-family: 'Work Sans', sans-serif;
        }
    }

    .manage {
        display: flex;
        width: 100%;
        justify-content: start;
        flex-direction: column;

        .day {
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 10px 0 10px 0;
        }

        h2 {
            font-size: 14px;
            color: #004FFF;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;
        }

        p{
            color: #C5C5C5
        }

        button {
            background-color: #004FFF;
            border: none;
            color: #fff;
            font-size: 11px;
            font-weight: bold;
            border-radius: 26px;
            width: 44px;
            height: 22px;
            margin: 5px 0 0 16px;
            cursor: pointer;
        }

        ul {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            list-style: none;
            padding: 0;

            .configDay {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: row;
                margin: 0 30px 0 0;
            }

            li {
                font-size: 14px;
                color: #403F4C;
                padding: 0 5px 0 0;

            span {
                    color: red;
                    font-size: 12px;
                }

                button {
                    background-color: white;
                    width: 55px;
                    cursor: pointer;
                    color: red;
                    font-size: 12px;
                    margin: 0;
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                }

            }
        }

    }

    /** Edit **/
    .selectDays{
        margin: 35px 0 0 28px;

        h2 {
            color: #403F4C;
            font-size: 28px;
            margin: 0;
            font-family: 'Quicksand',sans-serif;
            font-weight: 100;
        }

        h3 {
            color: #403F4C;
            font-size: 12px;
            margin: 0;
        }

        h4 {
            color: #403F4C;
            font-size: 14px;
            margin: 25px 0 0 0;
        }

        ul {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            justify-content: start;
            list-style: none;
            padding: 0;

            li {
                margin: 0 10px 0 0;
                padding: 5px 0 0 0;

                span{
                    font-size: 12px;
                    color: #403F4C;
                    margin-top: 5px;
                    font-family: 'Quicksand', sans-serif;
                }

                button {
                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    font-size: 14px;
                    border-radius: 26px;
                    width: 76px;
                    height: 28px;
                    margin-top: 0;
                    cursor: pointer;
                }

                button.active {
                    background-color: #004FFF;
                    color: #fff;
                    border: #004FFF;
                }
            }
        }

        .time{
            ul {
                list-style: none;
                margin-left: 24px;

                li {
                    display: flex;
                    flex-direction: column;
                }
            }

            select {
                background-color: #004FFF;
                color: #fff;
                border-radius: 26px;
                border: 0;
                width: 114px;
                height: 28px;
                padding-left: 10px;
                font-family: 'Work Sans', sans-serif;
                font-size: 14px;
                margin-top: 5px;
            }
        }

        .addSlot{
            button {
                background-color: #fff;
                border: 1px solid #B2B2B7;
                color: #B2B2B7;
                font-size: 14px;
                border-radius: 26px;
                width: 162px;
                height: 28px;
                margin: 20px 0 36px 24px;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
                font-weight: 500;
            }
        }

        .buttons {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            margin: 25px;
            padding: 0 15px 0 15px;
            cursor: pointer;
            font-family: 'Quicksand', sans-serif;

            button {
                background-color: transparent;
                border: 1px solid #787780;
                color: #403F4C;
                font-weight: bold;
                font-size: 11px;
                border-radius: 26px;
                width: 71px;
                height: 28px;
                margin-top: 8px;
                cursor: pointer;

                .fa{
                    margin-right: 5px;
                }

                &:last-child {
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    padding: 10px 20px;
                    height: 38px;
                    margin-left: 15px;
                    margin-top: 5px;
                    cursor: pointer;
                }
            }
        }
    }

    .pagamento{
            display: flex;
            align-items: center;
            gap: 40px;

            .plans{
              min-width: 150px;
              .payment{
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                h2{
                  font-size: 16px !important;
                  color: #403f4c;
                }
                h3{
                  text-transform: capitalize;
                  width: 100%;
                }
              }
            }
        }

    .inputManage{
        border-color: #B2B2B7 !important;
    }
`;

export const ModalCommission = styled.div`
  width: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  padding: 0 30px;

  .wrapperInputs {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .wrapperButtons {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  label{
    color: #403F4C;
    font-size: 14px;
    font-weight: bold;
  }

  input {
    width: auto;
    height: 32px;

    padding: 0 10px;
    margin: 2px 0 15px;
    border-radius: 26px;
    border: 1px solid #B2B2B7;

    font-size: 14px;
    color: #403F4C;
    font-family: 'Quicksand', sans-serif;
    background-color: transparent;

    @media(max-width: 720px) {
      width: auto;
    }

    &::placeholder {
      color: #87868F;
    }
  }
`;

export const FilterCss = styled(StudentManagementCss)`
    h2{
        font-size: 20px;
        font-weight: 400;
        color: #87868F;
        font-family: 'Quicksand', sans-serif;
        .fa{
            margin: 0 5px 0 0;
        }
    }

    .formulario{
        flex-direction: row;
        margin: 10px 0 0 0;

        .lineInput{
            display: flex;
            flex-direction: column;
            margin: 0 16px 0 0;
            width: 100%;
        }

        input {
            width: auto;

        }

        select{
            width: auto;
        }
    }

    .button{
        display: flex;
        justify-content: flex-end;
        width: 100%;

        button{
            width: 149px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 0 0 20px 0;
        }
    }

    .buttons{
        display: flex;
        justify-content: flex-end;
        font-family: 'Quicksand', sans-serif;
        align-items: center;

        .Users-wrapper-2 {
            position: relative;
            width: 81px;
            height: 28px;
        }
        button{
            width: 84px;
            height: 22px;
            border-radius: 26px;
            background: #fff;
            border: 1px solid #B2B2B7;
            color: #B2B2B7;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 14px 0 0 0;
            margin-right: 10px;
            font-family: 'Quicksand', sans-serif;

            &:last-child{
                width: auto;
                height: 32px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
                margin: 18px 18px 0 0;
                padding: 0 12px 0 12px;
            }


            &:disabled,
                button[disabled]{
                width: 58px;
            }

        }

        button.save {
          padding: 10px 20px;
            height: 22px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 10px 18px 0 0;
            font-family: 'Work Sans', sans-serif;
        }
    }
`;

export const Manage = styled.div`
  width: 95%;
  max-width: 1300px;
  margin: 0 auto;

    h3{
        font-size: 22px;
        color: #004FFF;
        font-weight: bold;
        font-family: 'Quicksand', sans-serif;
        margin: 20px 0;
        width: 100%;
        max-width: 66%;
        text-align: center;
    }


    .tabs{
        width: 100%;

        .tab-content{
            margin-bottom: 36px;

            .buttons-plans {
                display: flex;
                flex-direction: column;
                align-items: flex-end !important;

                .button-buy-more {
                    background-color: #004FFF !important;
                    color: #fff !important;
                    font-size: 11px;
                    font-family: "Quiscksand", sans-serif;
                    font-weight: 500;
                    width: auto !important;
                    height: auto !important;
                    padding: 6px 10px;
                    white-space: nowrap;
                    margin-top: 7px !important;
                    border: none !important;
                }
            }

            .buttons{
                display: flex;
                justify-content: center;
                margin-top: 10px;

                button{
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 26px;
                    width: auto;
                    height: 38px;
                    margin-top: 50px;
                    cursor: pointer;
                    font-family: 'Work Sans', sans-serif;
                    font-weight: 900;
                    padding: 0 12px 0 12px;

                }
            }
        }

        /** Tabs **/
        .tab-list {
            padding-left: 0;

            .tabsContent{
                margin: 0 auto;
                width: 100%;
                text-align: center;


                .tab-list-item {
                    display: inline-block;
                    list-style: none;
                    margin-bottom: -1px;
                    padding: 0;
                    margin-right: 24px;
                    cursor: pointer;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif;
                    color: #706F79;
                    font-weight: 500;
                }

                .tab-list-active {
                    color: #004FFF;
                    font-weight: bold;
                    border-bottom: 4px solid #004FFF;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif
                }
            }
        }

        /** Box **/
        .box{
            width: unset;
            height: 100%;
            background-color: #fff;
            margin-top: 25px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: row;
            padding: 15px 15px;
            gap: 10px;
            border-radius: 10px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
            flex-wrap: wrap;




        }


        .userName{
            h2{
                font-size: 24px;
                font-weight: 500;
                color: #87868F;
                margin:25px 0 0 100px;
                font-family: 'Quicksand', sans-serif;
            }
        }

        .viewUser{
            display: flex;
            width: 100%;
            flex-direction: row;
        }

        .MuiInput-underline-15:before {
            border-bottom: none;
        }

        .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
            border-bottom: none;
        }

        /** Personal**/
        .changePhoto{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 20%;

            h2{
                color: #403F4C;
                font-size: 14px;
                margin: 0 0 10px 0 !important;
            }

            .photo{
                display: flex;
                align-items: center;
                flex-direction: column;
            }

            .fileUpload {
                position: relative;
                overflow: hidden;
                margin: 10px;
                border-radius: 26px;
                border: 1px solid #787780;
                width: 93px;
                height: 20px;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                input.upload {
                    position: absolute;
                    top: 0;
                    right: 0;
                    margin: 0;
                    padding: 0;
                    font-size: 20px;
                    cursor: pointer;
                    opacity: 0;
                    filter: alpha(opacity=0);
                }

                span{
                    display: flex;
                    align-items: center;
                }
            }

            span{
                img{
                    padding: 0 5px 0 0;
                }
            }

        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: bold;
            }

            .addEmail{
                display: flex;

                input{
                    width: 460px;
                }
            }

            .label{
                margin: 0 0 -15px 0;
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            span.invalid {
                font-size: 10px;
                margin-left: 5px;
                color: red;
            }
            select{
                width: 220px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                font-family: 'Quicksand',sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            .selectClass{
                pointer-events: none;
                touch-action: none;


                .classToolId{
                  pointer-events: all;
                  touch-action: unset;
                  margin-top: 10px;
                }

                select, input{
                    border: none;
                    background-image: none;
                    padding: 0;
                }

                span{
                    display: none;
                }
            }



            .profile{
                display: flex;
                justify-content: flex-start;
                /* width: 100%; */
                /* max-width: 59%; */

                /* select{
                    width: 220px;
                    &:last-child{
                        display: none;
                    }
                } */

                /* .role{
                    width: 100%;
                    max-width: 34%;
                } */

                .active{
                    background-color: #00D36A;
                    color: #fff !important;
                    font-size: 18px;
                    font-weight: 500;
                    width: 126px;
                    border: none;
                    margin-left: 240px;
                }
            }

            input{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding: 0 10px;
                margin-bottom: 15px;
                background-color: transparent;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: #87868F;
            }

            input:invalid{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                /* border: 1px solid red; */
                padding-left: 10px;
                margin-bottom: 15px;
            }

            .inputs{
                display: flex;
                align-items: center;
                gap: 12px;



            .lineInputs{
                .gender{
                    width: 243px;
                }

                .MuiInput-input-14 {
                    width: 215px;
                    border: none;
                    height: 19px;
                    margin: 0;
                }

                .MuiFormControl-root-30 {
                    border: 1px solid;
                    border-radius: 26px;
                    border: 1px solid #B2B2B7;
                }

                input{
                    width: 220px;
                }

                select.userPhoneTypeId{
                    width: 300px;
                }

            }

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }

        }


            .telephone{
                input{
                    width: 220px;
                }

                button.addInput{
                    margin: 20px 0 0 0;
                    font-family: 'Work Sans', sans-serif;
                }
            }

            button.password{
              width: auto;
                padding: 8px 12px;
                border-radius: 26px;
                margin-left: 0;
                background: transparent;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                cursor: pointer;
                font-weight: 100;
                margin: 2px 0 44px 0;
            }

            .notification{
                display: flex;

                .switch__container{
                    margin: 5px 0 0 23px;

                    span{
                        margin-left: 47px;
                        font-size: 12px;
                        color: #707070;
                        font-family: 'Quicksand', sans-serif;
                    }
                }

                span.delete{
                    margin: 11px 0 0 0;
                    width: 55px;
                    font-weight: bold;
                }
            }

            .switchBox{
                display: flex;

                .labelNotify{
                    display: flex;
                    flex-direction: column;
                    width: auto !important;

                    .doubleClick{
                      color: #ccc !important;
                    }
                  }
            }




            .selects{
                display: flex;
                flex-direction: row;

            }

            .lineSelect{
                margin: 0 25px 0 0;

                p{
                    font-size: 11px;
                    margin-top: 22px;
                    color: #403F4C;
                }
            }

            span.delete {
                color: red;
                font-size: 10px;
                font-weight: bold;
                margin-top: 30px;
                float: left;
            }

            button.jsx-4179805763 {
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin: 0 0 1px 0 !important;
                background: #B2B2B7;
                border-radius: 0;
            }
            button.focus.jsx-4179805763  {
                background: #B2B2B7;
            }

            button.delete{
                width: 83px;
                height: 22px;
                border-radius: 26px;
                background: transparent;
                border: none;
                color: #FF5666;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 25px 0 20px 7px;

            }

        }

        /** Button Save **/
        .buttonSave{
            display: flex;
            justify-content: flex-end;

            button{
              padding: 10px 20px;
                height: 38px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
                margin: 24px 0 30px 0;
                font-family: 'Work Sans',sans-serif;
            }
        }

        input.jsx-4179805763  {
            width: 480px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
        }

        /** Plans **/
        .planBox{

            .box {
                flex-direction: column;


                .buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                    margin: 25px 35px 25px 0;
                    padding: 0 15px 0 15px;
                    cursor: pointer;

                    button {
                        background-color: transparent;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 71px;
                        height: 32px;
                        margin-top: 9px;
                        cursor: pointer;

                        &:last-child{
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            padding: 10px 20px;
                            height: 38px;
                            margin-top: 5px;
                            margin-left: 15px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .PlansBox {
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: flex-start;


                &:first-child{
                    margin-bottom: 0;
                    border-bottom: none;
                    padding-bottom: 0;
                }

                &:last-child{
                    border-bottom: none;
                }

                .chosenPlan {
                    flex-direction: row;
                    display: flex;
                    margin: 0;
                    width: 100%;
                    height: 80px;
                    padding: 10px 0 0 15px;
                    margin-left: 13px;
                    flex-wrap: wrap;

                h2 {
                        padding: 0 30px 0 0;
                        font-size: 15px;
                        color: #403F4C;
                        font-weight: bold;
                        margin: 0;
                    }

                    h3 {
                        padding: 0;
                        margin: 0;
                        font-size: 18px;
                        color: #403F4C;
                        font-weight: bold;
                    }

                    p {
                        color: #403F4C;
                        font-size: 15px;
                        padding: 0;
                        margin: 0 0 5px 0;
                    }

                    button {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 86px;
                        height: 28px;
                        margin-top: 5px;
                        cursor: pointer;

                        &:last-child {
                            background-color: #fff;
                            border: 1px solid #B2B2B7;
                            color: #B2B2B7;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 93px;
                            height: 28px;
                            margin: 5px 0 26px 10px;
                            cursor: pointer;
                        }
                    }

                }

                .last{
                    margin-bottom: 20px;
                }

                .plans {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    max-width: 170px;
                    width: 40%;


                    &:nth-child(2) {
                      max-width: 400px;
                    }

                    .changePlan {
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        padding-left: 10px;

                        h2 {
                            color: #403F4C;
                            font-size: 18px;
                            font-weight: bold;
                            width: max-content;
                            margin: 0 !important;
                        }

                        button {
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 86px;
                            height: 22px;
                            margin-top: 5px;
                            margin-right: 5px;
                            cursor: pointer;
                            font-family: 'Quicksand', sans-serif;

                            &:last-child {
                                background-color: #fff;
                                border: 1px solid #B2B2B7;
                                color: #B2B2B7;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 93px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }

                            .fa{
                                margin-left: 10px;
                            }
                        }
                    }

                    /** Controle Plano **/
                    .controlPlan{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        width: 100%;
                        gap: 40px;
                        flex-wrap: wrap;

                        .infos{
                            margin-bottom: 10px;
                            text-align: center;
                        }

                        h2{
                            font-size: 13px;
                            color: #9E9EA4;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand', sans-serif;
                        }

                        h3{
                            font-size: 14px;
                            color: #403F4C;
                            margin: 3px 0 0 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            text-align: left;
                            max-width: 100%;
                        }

                        span{
                            color: #004FFF;
                            font-size: 22px;
                            font-weight: bold;

                            &:last-child{
                                color: #004FFF;
                                font-size: 14px;
                                font-weight: 50
                            }
                        }
                    }

                    /** Números **/
                    .numbers{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: -3px;
                    }

                    /** Stock **/
                    .stock{
                      display: flex;
                      width: 100%;
                        hr {
                            height: 4px;
                            background-color: #004FFF;
                            width: 100%;
                            border: none;
                            margin: 9px 0 10px 0;
                            opacity: 1;
                        }

                        span{
                            color: #004FFF;
                            font-size: 12px;
                        }
                    }


                    /** Pagamento **/
                    .payment{
                        flex-direction: column;
                        margin-top: 7px;
                        width: auto;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                        }

                        h3{
                            font-size: 18px;
                            color: #87868F;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            display: flex;
                            align-items: center;

                            img{
                                margin-right: 8px;
                            }
                        }

                        button{
                            background-color: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            font-size: 11px;
                            border-radius: 26px;
                            width: auto;
                            height: 22px;
                            margin-top: 8px;
                            padding: 0 12px 0 12px;
                            cursor: pointer;
                        }

                        select {
                            width: 100%;
                            height: 32px;
                            border-radius: 26px;
                            border: 1px solid #403F4C;
                            padding-left: 10px;
                            margin-bottom: 15px;
                            color: #403F4C;
                            margin-right: 10px;
                            opacity: 0.4;
                        }
                    }


                    /** Valores **/
                    .value {
                        margin-top: 8px;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                        }

                        h3{
                            font-size: 18px;
                            color: #403F4C;
                            font-weight: normal;
                            margin-top: 4px;
                            margin: 0;
                            padding: 0;
                            max-width: 100%;
                            text-align: left;
                        }

                        button{
                            background-color: #fff;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 94px;
                            height: 22px;
                            margin-top: 8px;
                            cursor: pointer;
                        }

                    }

                    &:nth-child(2) {
                        flex-direction: column;
                    }

                    &:last-child button{

                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #787881;
                        font-size: 11px;
                        border-radius: 26px;
                        width: auto;
                        height: 22px;
                        margin-top: 5px;
                        cursor: pointer;
                        font-family: 'Quicksand', sans-serif;
                        padding: 0 7px 0 7px;

                        .fa{
                            margin-left: 7px;
                        }
                    }

                    .buttons{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 25px;
                        padding: 0 15px 0 15px;
                        cursor: pointer;

                        button{
                            background-color: transparent;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 71px;
                            height: 38px;
                            margin-top: 8px;
                            cursor: pointer;

                            &:last-child{
                                background-color: #004FFF;
                                border: none;
                                color: #fff;
                                font-weight: bold;
                                font-size: 11px;
                                border-radius: 26px;
                                padding: 10px 20px;
                                height: 38px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }

                        .cancel{
                            button{
                                background-color: transparent;
                                border: 1px solid #FF5666;
                                color: #FF5666;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 104px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }
                    }

                }

                .planCancel{
                    color: #FF5666;
                    padding: 4px 10px 0 10px;
                    height: 23px;
                    margin-top: 32px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: 'Quicksand', sans-serif;
                }
            }
        }

        /** box Big **/
        .boxBig {
          width: 100%;
          display: flex;
          gap: 26px;
          margin: 0 auto;
          flex-direction: column;
          flex-wrap: wrap;

          border-bottom: 1px solid #ccc;


                &:last-child {
                    border-bottom: none !important;
                }


            .itemBox {
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;
                flex-direction: row;



                h5{
                    padding: 0;
                    margin: 0;
                    font-weight: bold;
                    color: #87868F;
                }

                span{
                    color: #004FFF;
                }

                .levelTop {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    width: 100%;
                    max-width: 160px;

                    .levelTopLinguage {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .boxLanguage {
                            display: flex;
                            width: 100%;
                            justify-content: space-between;
                            flex-direction: column;

                            h5{
                                padding: 0;
                                margin: 0;
                                color: #87868F;
                            }

                            .language {
                                display: flex;
                                margin: 7px 0 13px 0;
                                align-items: center;

                                img {
                                    margin: 0 8px 0 0;
                                }

                                h5{
                                    font-size: 18px;
                                    color: #87868F;
                                    margin: 0;
                                    padding: 0;
                                    font-family: 'Quicksand',sans-serif;
                                    font-weight: 100;
                                }
                            }
                        }
                    }

                    .columLevel {
                        justify-content: flex-end;
                        display: flex;
                        width: 100%;

                        h5 {
                            text-align: right;
                            padding: 0;
                            margin: 0;
                            color: #87868F;
                        }
                    }

                }

                .another-grades{
                  align-items: center;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }

                .grades {
                    display: flex;
                    flex-direction: row;
                    align-items: center;


                    h6 {
                        margin:  0 10px 0 0;
                        color: #87868F;
                        font-size: 15px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: bold;
                    }

                    h5{
                        padding: 0;
                        margin: 0;
                        color: #87868F;
                        font-size: 14px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: normal;
                        font-weight: bold;
                        text-align: center;

                        span {
                            color: #004FFF;
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        /** Notifications **/
        .infoNotification {
            width: 100%;

            h2 {
                color: #403F4C;
                font-size: 18px;
                margin: 40px 0 0 52px;
                font-weight: 100;
                font-family: 'Quicksand', sans-serif;
            }

            ul {
                margin: 40px 0 0 57px;
                display: flex;
                width: 88%;
                flex-direction: column;

            li {
                    display: flex;
                    align-items: center;
                    padding: 0;
                    margin: 0;
                    height: 50px;

                    span {
                        width: 175px;
                        color: #403F4C;
                        font-size: 16px;
                        font-family: 'Quicksand', sans-serif;
                    }

                }
            }
        }

        /** Manage Available Hours **/
        .topManage {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            margin: 15px 25px 0 0;
            align-items: center;

            h2 {
                font-size: 18px;
                color: #403F4C;
                font-weight: normal;
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 14px;
                font-weight: bold;
                border-radius: 26px;
                width: auto;
                height: 38px;
                margin-top: 5px;
                padding: 12px;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
            }
        }

        .manage {
            display: flex;
            width: 100%;
            justify-content: start;
            flex-direction: column;

            .day {
                display: flex;
                align-items: center;
                flex-direction: row;
                margin: 10px 0 10px 0;
            }

            h2 {
                font-size: 14px;
                color: #004FFF;
                font-weight: 500;
                font-family: 'Work Sans', sans-serif;
            }

            p{
                color: #C5C5C5
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 11px;
                font-weight: bold;
                border-radius: 26px;
                width: 44px;
                height: 22px;
                margin: 5px 0 0 16px;
                cursor: pointer;
            }

            ul {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                list-style: none;
                padding: 0;

                .configDay {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row;
                    margin: 0 30px 0 0;
                }

                li {
                    font-size: 14px;
                    color: #403F4C;
                    padding: 0 5px 0 0;

                span {
                        color: red;
                        font-size: 12px;
                    }

                    button {
                        background-color: white;
                        width: 55px;
                        cursor: pointer;
                        color: red;
                        font-size: 12px;
                        margin: 0;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                    }

                }
            }

        }

        /** Edit **/
        .selectDays{
            margin: 35px 0 0 28px;

            h2 {
                color: #403F4C;
                font-size: 28px;
                margin: 0;
                font-family: 'Quicksand',sans-serif;
                font-weight: 100;
            }

            h3 {
                color: #403F4C;
                font-size: 12px;
                margin: 0;
                max-width: 72%;
            }

            h4 {
                color: #403F4C;
                font-size: 14px;
                margin: 25px 0 0 0;
            }

            ul {
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                justify-content: start;
                list-style: none;
                padding: 0;

                li {
                    margin: 0 10px 0 0;
                    padding: 5px 0 0 0;

                    span{
                        font-size: 12px;
                        color: #403F4C;
                        margin-top: 5px;
                        font-family: 'Quicksand', sans-serif;
                    }

                    button {
                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #B2B2B7;
                        font-size: 14px;
                        border-radius: 26px;
                        width: 76px;
                        height: 28px;
                        margin-top: 0;
                        cursor: pointer;
                    }

                    button.active {
                        background-color: #004FFF;
                        color: #fff;
                        border: #004FFF;
                    }
                }
            }

            .time{
                ul {
                    list-style: none;
                    margin-left: 24px;

                    li {
                        display: flex;
                        flex-direction: column;
                    }
                }

                select {
                    background-color: #004FFF;
                    color: #fff;
                    border-radius: 26px;
                    border: 0;
                    width: 114px;
                    height: 28px;
                    padding-left: 10px;
                    font-family: 'Work Sans', sans-serif;
                    font-size: 14px;
                    margin-top: 5px;
                }
            }

            .addSlot{
                button {
                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    font-size: 14px;
                    border-radius: 26px;
                    width: 100%;
                    height: 28px;
                    margin: 20px 0 36px 24px;
                    cursor: pointer;
                    font-family: 'Work Sans',sans-serif;
                    font-weight: 500;
                    padding: 0 10px 0 10px;
                }
            }

            .buttons {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                margin: 25px;
                padding: 0 15px 0 15px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

                button {
                    background-color: transparent;
                    border: 1px solid #787780;
                    color: #403F4C;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: auto;
                    height: 28px;
                    margin-top: 9px;
                    cursor: pointer;

                    .fa{
                        margin-right: 5px;
                    }

                    &:last-child {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        padding: 10px 20px;
                        height: 38px;
                        margin-left: 15px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                }
            }
        }

        .pagamento{
            display: flex;
            align-items: center;
            gap: 40px;

            .plans{
              min-width: 150px;
              .payment{
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                h2{
                  font-size: 16px !important;
                  color: #403f4c;
                }
                h3{
                  text-transform: capitalize;
                  width: 100%;
                }
              }
            }
        }
        .inputManage{
            border-color: #B2B2B7 !important;
        }

    }




`;

export const TableCss = styled.div`
    margin-top: 21px;

    .boxTable{
        display: flex;
        width: 100%;
        padding: 0 12px 0 10px;
        background-color: #fff;
        justify-content: space-between;
        border: 1px solid;
        flex-direction: row;

        .boxItem{
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            h3{
                font-size: 12px;
                color: #403F4C;
                font-weight: bold;
            }

            .itemTop{
                h3{
                    margin: 11px 139px 0 0;
                }
            }

        }
        hr{
            margin-top: 0;
        }
    }


    table{
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0 15px 0;

        tr{
            text-align: left;
            height: 35px;

            th{
                color: #403F4C;
                font-size: 12px;
                font-weight: bold;
            }

            :nth-child(2){
                border-top: 1px solid #B2B2B7;
            }
        }



        td {
            border-bottom: 1px solid #B2B2B7;
            height: 33px;
            font-size: 14px;
            color: #403F4C;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;

            span{
                color: #0ED572;
                font-weight: bold;
            }
            .inativo{
                color: #FF5666;
                font-weight: bold;
            }
            button{
                background-color: transparent;
                border: 1px solid #B2B2B7;
                border-radius: 26px;
                color: #87868F;
                font-size: 11px;
                width: 58px;
                height: 22px;
                float: right;
                cursor: pointer;
            }
        }
    }

`;

export const User = styled.div`
    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 199px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .avatarRound {
        border-radius: 50%;
        object-fit: cover;
    }


    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** changePhoto**/
    .changePhoto{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 40px 60px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin: 0 0 10px 0;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            opacity: 0.7;
            display: flex;
            align-items: center;
            justify-content: center;

            span{
                align-items: center;
                display: flex;
            }

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }
    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin: 40px 100px 0 0;
        width: 100%;

        /* .react-inputs-validation__textbox__container___3KXOM{
            width: 45%;
            margin-right: 5px;
        } */

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }


        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }


        select{
            width: 220px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
        }


        .profile{
            display: flex;
            justify-content: flex-start;
            margin-bottom: 25px;
            /* width: 100%; */
            /* max-width: 59%; */

            /* select{
                width: 220px;
                &:last-child{
                    display: none;
                }
            } */

            /* .role{
                width: 100%;
                max-width: 34%;
            } */

            .active{
                background-color: #00D36A;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
                font-family: 'Quicksand', sans-serif;
            }

            .inactive{
                background-color: red;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
            }
        }


        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding-left: 10px;
            margin-bottom: 15px;
            font-size: 14px;
            font-family: 'Quicksand', sans-serif;
        }

        .genderBox{
            margin-bottom: 25px;
        }


        .inputs{
            display: flex;
            align-items: center;
            gap: 12px;

            .lineInputs{
                .gender{
                    width: 243px;
                }


                .MuiInput-input-14 {
                    width: 215px;
                    border: none;
                    height: 19px;
                    margin: 0;
                }

                .MuiFormControl-root-30 {
                    border: 1px solid;
                    border-radius: 26px;
                    border: 1px solid #B2B2B7;
                }

                input{
                    width: 220px;
                }

                select.userPhoneTypeId{
                    width: 300px;
                }

            }

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }
        }
        button.deleteLast{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .removephone{
            margin: 0 0 0 -25px;
        }


    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 226px !important;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 0;
        margin-top: 0;
    }

    button.jsx-4179805763  {
        margin: 0 0 1px 0 !important;
    }

    input[type='number'] {
        -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

`;

export const FilterUser = styled(User)`
    width: 100%;
    .boxAddTeacher {
        width: 100%;

        padding: 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }

    .teacherListBox {
        width: 100%;
        padding: 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }

    .filterContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        padding: 20px;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);


        h2 {
            font-size: 20px;
            font-weight: 400;
            color: #87868F;
            font-family: 'Quicksand', sans-serif;
            .fa{
                margin: 0 5px 0 0;
            }
        }

        .inativo{
            color: #FF5666;
            font-weight: bold;
        }


        .formulario{
            flex-direction: row;
            margin: 10px 0 0 0;


            .lineInput{
                display: flex;
                flex-direction: column;
                margin: 0 16px 0 0;
                width: 100%;
                min-width: 10%;
            }

            input {
                width: auto;

            }

            select{
                width: auto;
            }
        }

        .button{
            width: 100%;
            display: flex;
            justify-content: flex-end;

            button{
                width: 149px;
                height: 38px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
                margin: 0 0 20px 0;
            }
        }

        .boxButton{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .buttons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 0px ;

            button{
                width: auto;
                height: 28px;

                padding: 0 12px;
                border-radius: 26px;
                margin: 10px 10px 0 0;
                background-color: #fff;
                border: 1px solid #B2B2B7;

                color: #787780;
                cursor: pointer;
                font-size: 11px;
                font-weight: 500;
                font-family: 'Quicksand',sans-serif;

                &:last-child{
                    width: auto;
                    height: 32px;

                    padding: 0 12px;
                    border-radius: 26px;
                    background: #004FFF;
                    border: 1px solid #004FFF;

                    color: #fff;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                }


                &:disabled,
                    button[disabled]{
                    width: 58px;
                }

            }

            button.save {
              padding: 10px 20px;
                height: 22px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 10px 18px 0 0;
                font-family: 'Work Sans', sans-serif;
            }


        }

        .buttonsSelect{
            display: flex;
            flex-direction: row;
            align-content: flex-start;
            font-family: 'Quicksand', sans-serif;
            align-items: flex-start;

            button {
                width: 84px;
                height: 32px;
                border-radius: 26px;
                background: #fff;
                border: 1px solid #B2B2B7;
                color: #B2B2B7;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin-right: 10px;
                font-family: 'Quicksand', sans-serif;
            }

            button.active {
                width: 84px;
                height: 32px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
            }

        }


        .teacherListBox{
            width: 100%;
            height: 100%;
            background-color: #fff;
            border-radius: 5px;
            padding: 15px;
            box-shadow: 1px 1px 4px 1px #DADADA;
            display: flex;
            align-items: flex-start;
            flex-direction: row;
            margin-top: 25px;

            h3 {
                margin-right: 20px;
                white-space: nowrap;
                font-size: 18px;
                font-family: 'Quicksand', sans-serif;
                font-weight: bold;
            }

            .switch__container{
                margin: 0px;
            }
        }
    }
`;

export const TableUser = styled.div`
    margin-top: 21px;

    .bigBoxTableStudent{
        width: auto;
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        table{
            width: 100%;
            border: none;
            border-collapse: collapse;
            background-color: #ffffff;

            thead {
                border-bottom: 1px solid #B2B2B7;
            }

            tr{
                text-align: left;
                height: 35px;

                th{
                    color: #403f4c;
                    font-size: 12px;
                    font-weight: bold;
                }

                :nth-child(2){
                    border-top: 1px solid #B2B2B7;
                }
            }

            td {
                position: relative;
                border-bottom: 1px solid #B2B2B7;
                height: 33px;
                font-size: 14px;
                color: #403f4c;
                font-weight: 400;
                font-family: "Work Sans", sans-serif;
                padding: 4px 0;

                .activo{
                    color: #0ED572;
                    font-weight: bold;
                }
                .inativo{
                    color: #FF5666;
                    font-weight: bold;
                }
                .pending{
                    color: #fdc35e;
                    font-weight: bold;
                }
                button{
                    background-color: transparent;
                    border: 1px solid #B2B2B7;
                    border-radius: 26px;
                    color: #87868F;
                    font-size: 11px;
                    width: 58px;
                    height: 22px;
                    float: right;
                    cursor: pointer;
                }
            }
        }
    }
`;

export const Billing = styled.div`

.planCancel{
                    color: #FF5666;
                    padding: 4px 10px 0 10px;
                    height: 23px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: 'Quicksand', sans-serif;
                }
    .box {
        /* width: 100%; */
        display: flex;
        align-items: center !important; ;
        justify-content: space-between !important; ;
        margin-top: 13px !important;
        flex-direction: row;
        padding: 15px 15px;
        background-color: #fff;

        &:nth-child(1) {
            margin-top: 20px !important;
        }

        &:nth-child(2) {
            margin-top: 20px !important;
        }


        .topBox {
            display: flex !important; ;
            align-items: center !important; ;

            h2 {
                margin-left: 15px !important;
                font-size: 20px;
                font-weight: bold;
            }
        }

        .titleBox{
            h2 {
                color: #004FFF;
                font-size: 16px;
                font-weight: bold;
                margin: 5px 15px 5px 60px;
            }
        }

        .boxInfo {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px 0 10px;
            flex-wrap: wrap;
            margin: 0 !important;

            .pagamento{
                display: flex;
                align-items: center;
                gap: 40px;

                .plansButtons{
                    min-width: 150px;
                    display: flex;
                    gap: 12px;

                    .payment{
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        h2{
                        font-size: 16px !important;
                        color: #403f4c;
                        font-weight: 500;
                        }
                        h3{
                        text-transform: capitalize;
                        width: 100%;
                        font-size: 22px;
                        color: #004FFF;
                        font-weight: bold;
                        font-family: 'Quicksand', sans-serif;
                        margin: 20px 0;
                        width: 100%;
                        max-width: 66%;
                        text-align: center;
                        }
                    }
                }

                .plans{
                    min-width: 150px;

                    .payment{
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;

                        h2{
                            font-size: 16px !important;
                            color: #403f4c;
                            font-weight: 500;
                        }

                        h3{
                            text-transform: capitalize;
                            width: 100%;
                            font-size: 22px;
                            color: #004FFF;
                            font-weight: bold;
                            font-family: 'Quicksand', sans-serif;
                            margin: 20px 0;
                            width: 100%;
                            max-width: 66%;
                            text-align: center;
                        }
                    }
                }
            }

            .infoBilling {
                flex-direction: column;

                h2 {
                    font-size: 13px;
                    color: #403F4C;
                    font-weight: bold;
                    margin: 0;
                    padding: 0
                }

                h3 {
                    font-size: 13px;
                    color: #403F4C;
                    font-weight: normal;
                    margin: 0;
                    padding: 0;
                    text-align: left;
                    max-width:initial;
                }

                span {
                    color: #00D36A;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    min-width: 55px;
                }

            }

            .word-wrap-break {
                word-break: break-all;
                width: 25%;
            }
        }

        .justify-start {
            justify-Content: flex-start !important;
        }

    }

    .buttons{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        padding: 0 15px 0 15px;
        cursor: pointer;

        button {
          background-color: #004FFF;
          border: none;
          color: #fff;
          font-size: 14px;
          border-radius: 26px;
          width: auto;
          height: 38px;
          margin-top: 50px;
          cursor: pointer;
          font-family: 'Work Sans', sans-serif;
          font-weight: 900;
          padding: 0 12px 0 12px;
        }

            .fa{
                margin-right: 7px;
            }
        }

`;

export const StudentTeacher = styled(User)`
    width: 100%;
    display: flex;
    flex-direction: column;


    .filterContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        padding: 20px;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        h2 {
            font-size: 20px;
            font-weight: 400;
            color: #87868F;
            font-family: 'Quicksand', sans-serif;
            .fa{
                margin: 0 5px 0 0;
            }
        }

        .inativo{
            color: #FF5666;
            font-weight: bold;
        }


        .formulario{
            display: flex;
            flex-direction: row;
            margin: 10px 0 0 0;
            align-items: center;
            justify-content: space-between;

            @media (max-width: 670px) {
              flex-wrap: wrap;
            }



            .lineInput{
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-right:16px;
            }

            .buttonsSelect{
                display: flex;
                flex-direction: row;
                align-content: flex-start;
                font-family: 'Quicksand', sans-serif;
                align-items: flex-start;
                margin-bottom: 10px;

                button {
                    width: 84px;
                    height: 32px;
                    border-radius: 26px;
                    background: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    cursor: pointer;
                    font-size: 11px;
                    font-weight: bold;
                    margin-right: 10px;
                    font-family: 'Quicksand', sans-serif;
                }

                button.active {
                    width: 84px;
                    height: 32px;
                    border-radius: 26px;
                    background: #004FFF;
                    border: 1px solid #004FFF;
                    color: #fff;
                    cursor: pointer;
                    font-size: 11px;
                    font-weight: bold;
                }

            }

            label {
                padding-bottom: 4px;
            }

            input {
                width: auto;

            }

            select{
                width: auto;
            }
        }

        .buttons{
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: -10px !important;

            button{
                width: 149px;
                height: 38px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
            }
        }

        .boxButton{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .buttons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-family: 'Quicksand', sans-serif;
            margin-bottom: 0px ;

            button{
                width: 84px;
                height: 28px;
                border-radius: 26px;
                background: #fff;
                border: 1px solid #B2B2B7;
                color: #787780;
                cursor: pointer;
                font-size: 11px;
                font-weight: 500;
                margin: 18px 0 0 0;
                margin-right: 10px;
                font-family: 'Quicksand',sans-serif;

                &:last-child{
                    width: auto;
                    height: 32px;
                    border-radius: 26px;
                    background: #004FFF;
                    border: 1px solid #004FFF;
                    color: #fff;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                    padding: 0 12px 0 12px;
                }


                &:disabled,
                    button[disabled]{
                    width: 58px;
                }

            }

            button.save {
              padding: 10px 20px;
                height: 22px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 10px 18px 0 0;
                font-family: 'Work Sans', sans-serif;
            }
        }

    }



    .teacherListBox{
        display: flex;
        background-color: #fff;
        border-radius: 5px;
        padding: 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        align-items: flex-start;
        flex-direction: row;
        margin-top: 25px;

        @media (max-width: 670px) {
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 10px;
          .switch__container{
              width: 100%;

              label{
                width: unset;
              }
          }
        }


        h3 {
            margin-right: 20px;
            white-space: nowrap;
            font-size: 18px;
            font-family: 'Quicksand', sans-serif;
            font-weight: bold;
        }

        .switch__container{
            margin: 0px;
        }
    }


`;

export const Form = styled.div`
    width: 100%;

    /* icons */
    .icons {
        padding-top: 40px;
        padding-bottom: 35px;
        margin: 0 auto;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #C5C3C9;
        font-weight: bold;

        &.active{
            color: var(--color-blue);
        }
        span{
            display: flex;
            width: 500px;
        }
        hr{
            border-top: 1px solid #C5C3C9;
            width: 40%;
            margin: 0;
            padding: 0;
            justify-content: end;
            display: flex;
            margin-top: 50px;

        }

        .icons-inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            svg{
                margin-bottom: 12px;

            }
        }

        .icons-inner-active {
            color: var(--color-blue);
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            /* svg{
                height: 25px;
                width: 18px;
                margin-bottom: 10px;
            } */
        }
    }


    .singIn{
        margin-top: 25px;
        border-right: 1px solid #E4E8EE;
        width: 94%;
        margin-left: 6%;

        form{

            label{
                font-size: 14px;
                color: #403F4C;
                font-weight: 500;
            }

            span{
                font-size: 10px;
                color: #97979E;
                margin-bottom: 3px;
                margin-left: 6px;
            }

            input{
                width: 90%;
                height: 29px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                padding-top: 4px;
                opacity: 0.4;
            }

            select{
                width: 90%;
                height: 34px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                opacity: 0.4;
            }

            ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                margin-top: 10px;
                color: #403F4C;
            }


        }

        .footerSingIn {
            position: relative;
            font-weight: 200;
            width: 100%;
            display: flex;
            flex-direction: row;
            -ms-flex-align: center;
            align-items: center;
            margin-top: 20px;

            hr {
                width: inherit;
                margin: 0;
                height: 1px;
            }

            div {
                width: 100%;
                position: absolute;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: center;
                justify-content: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .or-login-css {
                display: -ms-flexbox;
                display: flex;
                width: auto;
                padding-left: 10px;
                padding-right: 10px;
                padding-bottom: 5px;
                background-color: white;
                font-size: 12px;
            }

            .password{
                display: flex;
                height: 100%;
                width: 86%;
                align-items: center;
                justify-content: space-between;

                .forgot{
                    a{
                        color: #403F4C;
                        font-size: 12px;
                        text-decoration: underline;
                    }
                }
            }


        }

        .form-footer {
            height: 30px;
            width: 95%;
        }

        .form-footer_social-login{
            display: flex;
            justify-content: center;
            margin: 20px;

            img{
                width: 32px;
                height: 32px;
                margin: 0 30px 0 0;
            }
        }

        .switch__container{
            justify-content: center;
            text-align: center;
        }

        .switch--shadow + label {
            width: 32%;
        }

    }

    /* Verificar */
    .singIn{
        .account{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 35px;

            p{
                font-size: 14px;
            }

            a{
                color: #004FFF;
                font-weight: bold;
            }
        }
    }


    /** Text Prices **/
    .boxChangePlans{
        width: 100%;

        .textPrices{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 40px 0 10px 0;


            h2{
                color: #403F4C;
                font-size: 22px;
            }

            h3{
                color: #403F4C;
                font-size: 12px;
            }
        }

        .buttonBack{
            display: flex;
            width: 95%;
            justify-content: flex-end;
            align-items: center;
            margin: 26px 0 20px 0;

            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                width: 71px;
                height: 32px;
                cursor: pointer;
            }

            img{
                margin: 0 0 0 25px;
            }

        }


    }


    /** Change Plan **/
    .boxChange{
        background-color: #fff;
        width: 100%;
        height: 130px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        justify-content: space-between;

        .changePlan{
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 23px;

            h2{
                color: #39ADFE;
                font-size: 17px;
                text-align: center;
            }

            h3{
                color: #004FFF;
                font-size: 12px;
                font-weight: bold;
            }

            h4{
                color: #403F4C;
                font-size: 16px;
                font-weight: normal;
                text-decoration: line-through;
                margin: 0;
            }

            h5{
                color: #004FFF;
                font-size: 24px;
                font-weight: bold;
                margin: 0;
            }

            h6{
                color: #6D6A75;
                font-size: 14px;
                font-weight: normal;
                margin: 0;
            }

            p{
                color: #403F4C;
                font-size: 14px;
            }

            button{
                background-color: #004FFF;
                color: #fff;
                width: 80px;
                height: 40px;
                border-radius: 20px;
                border: none;
            }

        }

        .off{
            width: 58px;
            height: 18px;
            background-color: #004FFF;
            border-radius: 4px;
            color: #fff;
            text-align: center;
            font-size: 12px;
            font-weight: bold;
        }

    }


    /** Review **/
    .boxBig{
        background-color: transparent;
        width: 90%;
        height: 100%;
        display: flex;
        flex-direction: row;
        border-radius: 4px;
        margin-bottom: 50px;
        padding-top: 10px;
        margin: 0 auto;


        hr{
            height: 1px;
            width: 100%;
            margin: 45px 0 45px 0;
        }

        .box{
            width: 100%;
            height: 100%;
            padding: 20px 0 0 30px;
        }

        .buttonBack{
            display: flex;
            width: 95%;
            justify-content: flex-end;
            align-items: center;
            margin: 26px 0 20px 0;

            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                width: 71px;
                height: 32px;
                cursor: pointer;
            }

            img{
                margin: 0 0 0 25px;
            }

        }




        /** change **/
        .change{
            display: flex;
            align-items: center;
            margin-top: 25px;

            h2{
                font-size: 22px;
                color: #403F4C;
                font-weight: bold;
            }

            i{
                font-size: 12px;
                color: #97979E;
                margin: 3px 0 0 8px;

                img{
                    margin: 0 0 0 2px;
                }
            }
        }


        .infos{

            h3{
                font-size: 14px;
                color: #403F4C;
                font-weight: normal;
            }

            h4{
                font-size: 20px;
                color: #403F4C;
                margin: 5px 0 10px 0;
            }

            p{
                font-size: 14px;
                color: #6D6A75;
                font-weight: normal;
                margin: 9px 8px 0 0;
            }
        }

        .reviewPlan{
            display: flex;
            flex-direction: column;
            max-width: 100%;
        }

        .textPlanTop{
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-bottom: 25px;

            img{
                margin: 20px 10px 0 0;
            }

            h4{
                color: #39ADFE;
                padding-top: 0;
                margin: 18px 0 0;

            }

        }

        .textPlan{
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
        }

        .infoPlan{
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            width: 100%;
            margin: 0 0 10px 0;

            h5{
                margin: 5px 0 10px 0;
                color: #97979E;
            }

            select {
                width: auto;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                margin-right: 10px;
                opacity: 0.4;
            }

            .language{
                display: flex;
                margin: 0 10px 0 0;

                h5{
                    margin: 0 0 0 6px;
                    text-align: left;
                    color: #403F4C;
                    font-size: 14px;
                }

                .input-lingo{
                    height: 32px;
                }
            }

            .textBottom{
                display: flex;
                width: 100%;
            }


        }

        .textBottom{
            display: flex;
            justify-content: flex-end;

            select {
                width: auto;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                margin-right: 10px;
                opacity: 0.4;
            }
        }

        .textPay{
            display: flex;
            justify-content: flex-end;
            width: 92%;
            text-align: right;
            margin: 20px 0 30px 0;

            .total{

                h5{
                    font-size: 15px;
                    color: #403F4C;
                    font-weight: bold;
                    opacity: 0.4;
                    margin: 65px 0 0 0;
                }
            }

            .price{
                h5{
                    font-size: 28px;
                    color: #004FFF;
                    font-weight: bold;
                    margin: 0;
                }

                span{
                    font-size: 14px;
                    color: #6D6A75;
                }
            }

            .dollar{
                span{
                    font-size: 12px;
                    color: #6D6A75;
                }
            }

        }
    }


    .review{
        .box{
            &:first-child {
                display:none;
            }

            &:nth-child(2) {
                display: table;
	            width: 100%;
            }

        }
    }

    /** Confirmation **/
    .confirmation{
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 40px;

        h2{
            color: #00D36A;
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }

        img{
            margin: 25px auto;
            display: flex;
        }

        p{
            display: flex;
            font-size: 16px;
            color: #403F4C;
            text-align: center;
            margin-bottom: 50px;
        }

    }




    /* classe retirar depois */
    .fix-big{
        width: 90% !important;
        margin: 0 auto;
        padding-top: 10px;
    }

`;

export const Buttons = styled.div`
    width: 90%;
    display: flex;
    justify-content: flex-end;
    margin: 25px;

    .footer-btns{
        display: flex;
        justify-content: space-between;

        .button{
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            width: 200px;
            height: 38px;
            border-radius: 26px;
            background-color: #004FFF;
            border:  none;
            cursor: pointer;
            margin-top: 50px;
        }

        a{
            color: #FF5666;
            font-size: 12px;
            font-weight: 500;
            margin-right: 10px;
            text-decoration: none;
        }

        .save{
                button{
                    color: #787780;
                    font-size: 14px;
                    font-weight: bold;
                    width: 71px;
                    height: 32px;
                    border-radius: 26px;
                    background-color: transparent;
                    border: none;
                    cursor: pointer;
                    border: 1px solid #787780;
                    margin-top: 4px;
            }
        }
    }

`;

export const DivSubscription = styled.div`
    .boxRow{
        width: 100%;
        height: 100%;
        background-color: #fff;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-direction: row;
        padding: 10px 0 20px 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);


        .inputNumberClasses, .selectActivePlan{
          height: 32px;
          border-radius: 26px;
          border: 1px solid #B2B2B7;
          color: #403F4C;
          padding: 0 10px;
          margin-bottom: 15px;
          background-color: transparent;
          font-family: 'Quicksand',sans-serif;
          font-size: 14px;
          margin-top: 2px;
          min-width: 200px;
        }

        .button-blue {
          background-color: #004fff;
          border: 1px solid #004fff;
          width: 84px;
          height: 32px;
          border-radius: 26px;
          color: #fff;
          font-size: 11px;
          font-weight: bold;
          cursor: pointer;
          margin: 0 !important;
        }

        &:nth-child(1) {
            margin-top: 25px;
        }
    }

    label {
        font-size: 15px;
        color: #403F4C;
        font-weight: bold;
        margin: 0;
        padding: 0;
        font-family: 'Quicksand',sans-serif;
        text-transform: uppercase;
        text-align: left;    }

    span {
        font-size: 15px;
        color: #87868F;
        margin: 0;
        padding: 0;
        font-family: 'Quicksand',sans-serif;
        font-weight: 100;
        text-align: left;
        text-transform: capitalize;
    }

    .boxColumn {
        display: flex;
        flex-direction: column;
    }

    /* Flex Item */
    .item {
        margin: 5px 65px 0 0;
        text-align: center;
        font-size: 1.5em;
    }


    .active{
        color: #0ED572;
        font-weight: bold;
        font-size: 15px;
        text-align: left;
    }

    .deactive{
        color: #FF5666;
        font-weight: bold;
    }

    button {
        width: 84px;
        height: 32px;
        border-radius: 26px;
        background: #fff;
        border: 1px solid #B2B2B7;
        color: #B2B2B7;
        cursor: pointer;
        font-size: 11px;
        font-weight: bold;
        margin: 14px 0 0 0;
        margin-right: 10px;
        font-family: 'Quicksand',sans-serif;
    }
`;

export const DivTickets = styled.div`

    .boxRow{
        width: auto;
        height: 100%;
        background-color: #fff;
        margin-top: 10px;
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 10px 10px 10px 10px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        &:nth-child(1) {
            margin-top: 25px;
        }
    }

    label {
        font-size: 12px;
        color: #B2B1B6;
        font-weight: bold;
        margin: 0;
        padding: 0;
        font-family: 'Quicksand',sans-serif;
    }

    span {
        font-size: 14px;
        color: #403F4C;
        font-weight: 100;
        margin: 0;
        padding: 0;
        font-family: 'Work Sans', sans-serif;
    }

    .boxColumn {
        display: flex;
        flex-direction: column;
    }


    /* Flex Item */
    .item {
        margin: 5px;
        text-align: left;
        font-size: 1.5em;
        flex-grow: 1;
    }

    .closed{
        color: rgba(64, 63, 76, .7);
        font-weight: 800;
        text-transform: capitalize;
    }

    .open{
        color: blue;
        font-weight: bold;
        text-transform: capitalize;
    }

    .progress{
        color: #0ED572;
        font-weight: bold;
        text-transform: capitalize;
    }

    .cancelled{
        color: #FF5666;
        font-weight: bold;
        text-transform: capitalize;
    }

    .pending{
        color: #fdc35e;
        font-weight: bold;
    }


    button {
        background-color: transparent;
        border: 1px solid #B2B2B7;
        border-radius: 26px;
        color: #87868F;
        font-size: 11px;
        width: 58px;
        height: 22px;
        float: right;
        cursor: pointer;
    }

`;

export const Next = styled.div`
    h2{
        font-size: 32px;
        font-weight: 500;
        color: #403F4C;
        margin: 0 0 0 81px;
    }

    .active {
        background-color: #004FFF;
        color: #fff;
        border: #004FFF;
    }


    .nextClass{
       margin: 0 0 0 0;
       width: 100%;
       display: flex;

       h2{
            margin: 0;
            font-weight: 300;
            color: #004FFF;

            strong{
                font-weight: 500;
            }
        }


       .borderCancelled{
            border-left: 4px solid #FF5666;
            width: 1px;
            border-radius: 73px 0 0 72px;
            height: auto;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            margin: 15px -4px 0 0px;
            position: relative;
            z-index: 9999;
            background-color: #FF5666;
        }

       .boxClass{
            width: 100%;
            padding: 15px;
            margin-top: 15px;
            border-radius: 10px;
            background-color: #FFF;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

            &:nth-child(1) {
                margin-top: 20px;
            }
       }

       h3{
           color: #403F4C;
           font-size: 15px;
           font-weight: bold;
           margin: 0 0 6px 0;
       }

       .infos{
           display: flex;
           justify-content: space-between;
           align-items: baseline;
           flex-wrap: wrap;

           .classContent{
                display: flex;
                /* margin-bottom: 10px; */
                align-items: baseline;
                /* height: 35px;  */

                .classAndTeacher{
                    display: flex;
                    margin: 1px 0 0 0;

                    h4{
                        margin: 0 15px 0 0;
                    }
                }
           }

           .itemInfo{
               display: flex;
               align-items: center;
           }

           .status{
                display: flex;
                align-items: center;

                .run{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

               h4{
                   &:first-child{
                   color: #00D36A;
                   }

                   &.cancel{
                       color: red;
                       font-size: 12px;
                   }

                   .fa{
                        margin-left: 5px;
                   }

               }

           }

           button{
                color: #787780;
                font-size: 12px;
                font-weight: 500;
                border: 1px solid #787780;
                width: 84px;
                height: 22px;
                border-radius: 26px;
                background-color: transparent;
                cursor: pointer;
               }

           h4{
                font-size: 14px;
                color: #5A6C96;
                font-weight: 500;
                margin: 0 25px 0 0;
                display: flex;
                align-items: center;
           }

           h5.scheduleWithoutTeacher{
                font-size: 14px;
                color: #004fff;
                font-weight: 500;
                margin: 0 25px 0 0;
                display: flex;
                align-items: center;
           }

           h4.cancel{
                font-size: 14px;
                color: red;
                font-weight: 500;
                margin: 0 25px 0 0;
                display: flex;
                align-items: center;
           }


       }

       img{
           width: 18px !important;
           height: 12px !important;
           margin: 0 8px 0 0;
       }
   }

`;

export const PersonalInfoStyled = styled.div`
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;

    h3{
        font-size: 22px;
        color: #004FFF;
        font-weight: bold;
        font-family: 'Quicksand', sans-serif;
        margin: 20px 0;
        width: 100%;
        max-width: 66%;
        text-align: center;
    }

    .labelNotify{
      display: flex;
      flex-direction: column;
      width: auto;

      .doubleClick{
        color: #ccc !important;
      }
    }
    .tabs{
        width: 100%;

        .tab-content{
            margin-bottom: 36px;


            @media (max-width: 670px) {
              .box{
                width: 90% !important;
                justify-content: center;

                .formulario{

                  .notification{
                    flex-wrap: wrap;
                    gap: 10px;

                    .switchBox{
                      width: 100% !important;
                    }

                    button{
                      margin: 0 !important;
                      width: 100%;
                    }
                  }
                  input{
                    width: 100%;
                    padding: 0 0 0 10px;
                  }
                }
              }
            }

            .buttons-plans {
                display: flex;
                flex-direction: column;
                align-items: flex-end !important;

                .button-buy-more {
                    background-color: #004FFF !important;
                    color: #fff !important;
                    font-size: 11px;
                    font-family: "Quiscksand", sans-serif;
                    font-weight: 500;
                    width: auto !important;
                    height: auto !important;
                    padding: 6px 10px;
                    white-space: nowrap;
                    margin-top: 7px !important;
                    border: none !important;
                }
            }

            .buttons{
                display: flex;
                justify-content: center;
                margin-top: 10px;

                button{
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 26px;
                    width: auto;
                    height: 38px;
                    margin-top: 50px;
                    cursor: pointer;
                    font-family: 'Work Sans', sans-serif;
                    font-weight: 900;
                    padding: 0 12px 0 12px;

                }
            }
        }

        /** Tabs **/
        .tab-list {
            padding-left: 0;

            .tabsContent{
                margin: 0 auto;
                width: 100%;
                text-align: center;


                .tab-list-item {
                    display: inline-block;
                    list-style: none;
                    margin-bottom: -1px;
                    padding: 0;
                    margin-right: 24px;
                    cursor: pointer;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif;
                    color: #706F79;
                    font-weight: 500;
                }

                .tab-list-active {
                    color: #004FFF;
                    font-weight: bold;
                    border-bottom: 4px solid #004FFF;
                    font-size: 16px;
                    font-family: 'Quicksand', sans-serif
                }
            }
        }

        /** Box **/
        .box{
            width: unset;
            height: 100%;
            background-color: #fff;
            margin-top: 25px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: row;
            padding: 50px 15px 10px;
            gap: 10px;
            border-radius: 10px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
            flex-wrap: wrap;
        }


        .userName{
            h2{
                font-size: 24px;
                font-weight: 500;
                color: #87868F;
                margin:25px 0 0 100px;
                font-family: 'Quicksand', sans-serif;
            }
        }

        .viewUser{
            display: flex;
            width: 100%;
            flex-direction: row;
        }

        .MuiInput-underline-15:before {
            border-bottom: none;
        }

        .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
            border-bottom: none;
        }

        /** Personal**/
        .changePhoto{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 20%;

            h2{
                color: #403F4C;
                font-size: 14px;
                margin: 0 0 10px 0 !important;
            }

            .photo{
                display: flex;
                align-items: center;
                flex-direction: column;
            }

            .fileUpload {
                position: relative;
                overflow: hidden;
                margin: 10px;
                border-radius: 26px;
                border: 1px solid #787780;
                width: 93px;
                height: 20px;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                input.upload {
                    position: absolute;
                    top: 0;
                    right: 0;
                    margin: 0;
                    padding: 0;
                    font-size: 20px;
                    cursor: pointer;
                    opacity: 0;
                    filter: alpha(opacity=0);
                }

                span{
                    display: flex;
                    align-items: center;
                }
            }

            span{
                img{
                    padding: 0 5px 0 0;
                }
            }

        }

        .wrapperBlock {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 20px 0;
            border-bottom: 3px solid #d5d5d9;

            button {
                margin: 0 0 12px 0 !important;
            }
        }

        .textBlock {
            color: #5778FB;
            font-size: 24px;
            font-weight: 700;
            line-height: 30px;
            padding-bottom: 12px;
        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;

            @media (max-width: 670px) {
              width: 95%;
            }

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: bold;
            }

            .addEmail{
                display: flex;

                input{
                    width: 460px;
                }
            }

            .label{
                margin: 0 0 -15px 0;
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            span.invalid {
                font-size: 10px;
                margin-left: 5px;
                color: red;
            }
            select{
                width: 220px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                font-family: 'Quicksand',sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            .selectClass{
                pointer-events: none;
                touch-action: none;


                .classToolId{
                  pointer-events: all;
                  touch-action: unset;
                  margin-top: 10px;
                }

                select, input{
                    border: none;
                    background-image: none;
                    padding: 0;
                }

                span{
                    display: none;
                }
            }

            .profile{
                display: flex;
                justify-content: flex-start;

                .active{
                    background-color: #00D36A;
                    color: #fff !important;
                    font-size: 18px;
                    font-weight: 500;
                    width: 126px;
                    border: none;
                    margin-left: 240px;
                }
            }

            input{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding: 0 10px;
                margin-bottom: 15px;
                background-color: transparent;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                margin-top: 2px;
            }

            ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: #87868F;
            }

            .addInput{
                width: 128px;
                height: 32px;
                border-radius: 26px;
                margin: 0 24px;
                background: transparent;
                border: 1px solid #B2B2B7;
                color: #87868F;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
            }

            input:invalid{
                width: 460px;
                height: 32px;
                border-radius: 26px;
                /* border: 1px solid red; */
                padding-left: 10px;
                margin-bottom: 15px;
            }

            .timezoneCard{
                margin-bottom: 0 !important;
                div:nth-child(2){
                  width: 480px !important;

                  input{
                    width: 100% !important;
                  }
                  ul{
                    width: 480px !important;
                    li{
                      width: 100% !important;
                      button{
                        width: 100% !important;
                      }
                    }
                  }
                }
            }

            .customGroups-list {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;

                .customGroups {
                    display: flex;
                    align-items: center;
                    background-color: transparent;
                    padding: 6px 12px;
                    border-radius: 999px;
                    border: 1px solid rgb(117, 117, 117);

                    span {
                        color: #403F4C;
                        font-size: 14px;

                    }
                }

                .remove-btn {
                    background: none;
                    border: none;
                    color: #c00;
                    margin-left: 8px;
                    font-size: 16px;
                    cursor: pointer;
                    transition: color 0.2s ease;
                }
            }

            .inputs{
                display: flex;
                align-items: center;
                gap:12px;

              .timezoneCard{
                div:nth-child(2){
                  width: 480px !important
                }
              }

                .lineInputs{
                    .gender{
                        width: 243px;
                    }

                    .MuiInput-input-14 {
                        width: 215px;
                        border: none;
                        height: 19px;
                        margin: 0;
                    }

                    .MuiFormControl-root-30 {
                        border: 1px solid;
                        border-radius: 26px;
                        border: 1px solid #B2B2B7;
                    }

                    input{
                        width: 220px;
                    }

                    select.userPhoneTypeId{
                        width: 300px;
                    }

                }

                p{
                    font-size: 11px;
                    color: #87868F;
                    margin-top: 22px;
                }
            }

            .wrapperSelectTeacher {
                display: flex;
                gap: 15px;
                flex-direction: row;
                align-items: center;
                margin: 0 0 13px;

                .buttonSelectTeacher {
                    width: 130px;
                    height: 28px;
                    border-radius: 26px;
                    background-color: #fff;
                    border: 1px solid #b2b2b7;
                    margin: 0;

                    color: #b2b2b7;
                    font-size: 14px;
                    cursor: pointer;

                    &:hover {
                        filter: brightness(0.9);
                    }
                }

                .buttonSelectTeacherActive {
                    color: #fff;
                    background-color: #004fff;
                    border: 1px solid #004fff;
                }

                .wrapperInfoBilingue {
                    border-radius: 10px;
                    background: #004FFF;
                }

                .textInfoBilingue {
                    text-align: justify;
                }

                .linguitoPNG {
                    width: 45px;
                    height: 35px;
                }
            }

            .wrapperLanguage {
                margin-bottom: 25px;
                border-bottom: 3px solid #d5d5d9;

                .languageMain{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }

                .divSeparation{
                    width: 100%;
                    display: flex;
                    margin-bottom: 20px;
                    border-bottom: 1px solid #d5d5d9;
                }

                .otherLanguage{
                    .wrapperLabel {
                        width: 100%;
                        display: flex;
                        margin-bottom: 10px !important;

                        label {
                            color: #5778FB;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: normal;

                            margin-bottom: 13px;
                        }
                    }

                    .wrapperOtherLanguage{
                        width: 100%;
                        display: flex;
                        gap: 25px;
                        flex-wrap: wrap;
                        align-items: center;

                        select {
                            margin-right: 10px;
                        }

                        .buttonRemovelanguage {
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            width: 35px;
                            height: 35px;
                            margin: 0 0 15px 0;
                            border-radius: 50%;
                            background: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            cursor: pointer;
                            font-size: 11px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .wrapperConfigButtons{
                width: 100%;
                display: flex;
                gap: 25px;
            }


            .telephone{
                input{
                    width: 220px;
                }

                button.addInput{
                    margin: 20px 0 0 0;
                    font-family: 'Work Sans', sans-serif;
                }
            }

            button.addInput{
                width: 132px;
                height: 32px;
                border-radius: 26px;
                margin-left: 20px;
                background: transparent;
                border: 1px solid #403F4C;
                color: #403F4C;
                font-family: 'Work Sans', sans-serif;
                font-size: 14px;
                cursor: pointer;
                margin-bottom: 22px;
                font-weight: 500;
            }

            button.password{
              width: auto;
                padding: 8px 12px;
                border-radius: 26px;
                margin-left: 0;
                background: transparent;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                font-family: 'Quicksand', sans-serif;
                font-size: 14px;
                cursor: pointer;
                font-weight: 100;
                margin: 2px 0 44px 0;
            }

            .notification{
                display: flex;

                .switch__container{
                    margin: 5px 0 0 23px;

                    span{
                        margin-left: 47px;
                        font-size: 12px;
                        color: #707070;
                        font-family: 'Quicksand', sans-serif;
                    }
                }

                span.delete{
                    margin: 11px 0 0 0;
                    width: 55px;
                    font-weight: bold;
                }
            }

            .switchBox{
                display: flex;
            }



            .selects{
                display: flex;
                flex-direction: row;

            }

            .lineSelect{
                margin: 0 25px 0 0;

                p{
                    font-size: 11px;
                    margin-top: 22px;
                    color: #403F4C;
                }
            }

            span.delete {
                color: red;
                font-size: 10px;
                font-weight: bold;
                margin-top: 30px;
                float: left;
            }

            button.jsx-4179805763 {
                width: 460px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin: 0 0 1px 0 !important;
                background: #B2B2B7;
                border-radius: 0;
            }
            button.focus.jsx-4179805763  {
                background: #B2B2B7;
            }

            button.delete{
                width: 83px;
                height: 22px;
                border-radius: 26px;
                background: transparent;
                border: none;
                color: #FF5666;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 25px 0 20px 7px;

            }

        }

        /** Button Save **/
        .buttonSave{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin: 30px 0;

            button{
                margin: 0;
                padding: 10px 20px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;

                color: #fff;
                cursor: pointer;
                font-size: 14px;
                font-weight: bold;
            }

            button.back{
                gap: 5px;
                width: 72px;
                height: 28px;
                display: flex;
                align-items: center;

                border-radius: 26px;
                background: transparent;
                border: 1px solid #787780;

                color: #787780;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
            }
        }

        input.jsx-4179805763  {
            width: 480px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
        }

        /** Plans **/
        .planBox{

            .box {
                flex-direction: column;



                .buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                    margin: 25px 35px 25px 0;
                    padding: 0 15px 0 15px;
                    cursor: pointer;

                    button {
                        background-color: transparent;
                        border: 1px solid #787780;
                        color: #403F4C;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 71px;
                        height: 32px;
                        margin-top: 9px;
                        cursor: pointer;

                        &:last-child{
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            padding: 10px 20px;
                            height: 38px;
                            margin-top: 5px;
                            margin-left: 15px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .PlansBox {
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;


                &:first-child{
                    margin-bottom: 0;
                    border-bottom: none;
                    padding-bottom: 0;
                }

                &:last-child{
                    border-bottom: none;
                }

                .chosenPlan {
                    flex-direction: row;
                    display: flex;
                    margin: 0;
                    width: 100%;
                    height: 80px;
                    padding: 10px 0 0 15px;
                    margin-left: 13px;
                    flex-wrap: wrap;

                h2 {
                        padding: 0 30px 0 0;
                        font-size: 15px;
                        color: #403F4C;
                        font-weight: bold;
                        margin: 0;
                    }

                    h3 {
                        padding: 0;
                        margin: 0;
                        font-size: 18px;
                        color: #403F4C;
                        font-weight: bold;
                    }

                    p {
                        color: #403F4C;
                        font-size: 15px;
                        padding: 0;
                        margin: 0 0 5px 0;
                    }

                    button {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-size: 11px;
                        border-radius: 26px;
                        width: 86px;
                        height: 28px;
                        margin-top: 5px;
                        cursor: pointer;

                        &:last-child {
                            background-color: #fff;
                            border: 1px solid #B2B2B7;
                            color: #B2B2B7;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 93px;
                            height: 28px;
                            margin: 5px 0 26px 10px;
                            cursor: pointer;
                        }
                    }

                }

                .last{
                    margin-bottom: 20px;
                }

                .plans {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    /* max-width: 170px; */
                    width: 40%;


                    &:nth-child(2) {
                      max-width: 400px;
                    }

                    .changePlan {
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        padding-left: 10px;

                        h2 {
                            color: #403F4C;
                            font-size: 18px;
                            font-weight: bold;
                            width: 100%;
                            margin: 0 !important;
                        }

                        button {
                            background-color: #004FFF;
                            border: none;
                            color: #fff;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 86px;
                            height: 22px;
                            margin-top: 5px;
                            margin-right: 5px;
                            cursor: pointer;
                            font-family: 'Quicksand', sans-serif;

                            &:last-child {
                                background-color: #fff;
                                border: 1px solid #B2B2B7;
                                color: #B2B2B7;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 93px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }

                            .fa{
                                margin-left: 10px;
                            }
                        }
                    }

                    /** Controle Plano **/
                    .controlPlan{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        width: 100%;
                        gap: 40px;
                        flex-wrap: wrap;

                        .infos{
                            margin-bottom: 10px;
                            text-align: center;
                        }

                        h2{
                            font-size: 13px;
                            color: #9E9EA4;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand', sans-serif;
                        }

                        h3{
                            font-size: 14px;
                            color: #403F4C;
                            margin: 3px 0 0 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            text-align: left;
                            max-width: 100%;
                        }

                        span{
                            color: #004FFF;
                            font-size: 22px;
                            font-weight: bold;

                            &:last-child{
                                color: #004FFF;
                                font-size: 14px;
                                font-weight: 50
                            }
                        }
                    }

                    /** Números **/
                    .numbers{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: -3px;
                    }

                    /** Stock **/
                    .stock{
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                        hr {
                            height: 4px;
                            background-color: #004FFF;
                            width: 100%;
                            border: none;
                            margin: 9px 0 10px 0;
                            opacity: 1;
                        }

                        span{
                            color: #004FFF;
                            font-size: 12px;
                        }
                    }


                    /** Pagamento **/
                    .payment{
                        flex-direction: column;
                        margin-top: 7px;
                        width: auto;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                        }

                        h3{
                            font-size: 18px;
                            color: #87868F;
                            margin: 0;
                            padding: 0;
                            font-family: 'Quicksand',sans-serif;
                            font-weight: 100;
                            display: flex;
                            align-items: center;

                            img{
                                margin-right: 8px;
                            }
                        }

                        button{
                            background-color: transparent;
                            border: 1px solid #FF5666;
                            color: #FF5666;
                            font-size: 11px;
                            border-radius: 26px;
                            width: auto;
                            height: 22px;
                            margin-top: 8px;
                            padding: 0 12px 0 12px;
                            cursor: pointer;
                        }

                        select {
                            width: 100%;
                            height: 32px;
                            border-radius: 26px;
                            border: 1px solid #403F4C;
                            padding-left: 10px;
                            margin-bottom: 15px;
                            color: #403F4C;
                            margin-right: 10px;
                            opacity: 0.4;
                        }
                    }


                    /** Valores **/
                    .value {
                        margin-top: 8px;

                        h2{
                            font-size: 15px;
                            color: #87868F;
                            font-weight: bold;
                            margin: 0;
                            padding: 0;
                        }

                        h3{
                            font-size: 18px;
                            color: #403F4C;
                            font-weight: normal;
                            margin-top: 4px;
                            margin: 0;
                            padding: 0;
                            max-width: 100%;
                            text-align: left;
                        }

                        button{
                            background-color: #fff;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 94px;
                            height: 22px;
                            margin-top: 8px;
                            cursor: pointer;
                        }

                    }

                    &:nth-child(2) {
                        flex-direction: column;
                    }

                    &:last-child button{

                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #787881;
                        font-size: 11px;
                        border-radius: 26px;
                        width: auto;
                        height: 22px;
                        margin-top: 5px;
                        cursor: pointer;
                        font-family: 'Quicksand', sans-serif;
                        padding: 0 7px 0 7px;

                        .fa{
                            margin-left: 7px;
                        }
                    }

                    .buttons{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 25px;
                        padding: 0 15px 0 15px;
                        cursor: pointer;

                        button{
                            background-color: transparent;
                            border: 1px solid #787780;
                            color: #403F4C;
                            font-weight: bold;
                            font-size: 11px;
                            border-radius: 26px;
                            width: 71px;
                            height: 38px;
                            margin-top: 8px;
                            cursor: pointer;

                            &:last-child{
                                background-color: #004FFF;
                                border: none;
                                color: #fff;
                                font-weight: bold;
                                font-size: 11px;
                                border-radius: 26px;
                                padding: 10px 20px;
                                height: 38px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }

                        .cancel{
                            button{
                                background-color: transparent;
                                border: 1px solid #FF5666;
                                color: #FF5666;
                                font-size: 11px;
                                border-radius: 26px;
                                width: 104px;
                                height: 22px;
                                margin-top: 5px;
                                cursor: pointer;
                            }
                        }
                    }

                }

                .planCancel{
                    color: #FF5666;
                    padding: 4px 10px 0 10px;
                    height: 23px;
                    font-size: 15px;
                    font-weight: bold;
                    font-family: 'Quicksand', sans-serif;
                }
            }
        }

        /** box Big **/
        .boxBig {
          width: 100%;
          display: flex;
          gap: 26px;
          margin: 0 auto;
          flex-direction: column;
          flex-wrap: wrap;

          border-bottom: 1px solid #ccc;


                &:last-child {
                    border-bottom: none !important;
                }


            .itemBox {
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;
                flex-direction: row;



                h5{
                    padding: 0;
                    margin: 0;
                    font-weight: bold;
                    color: #87868F;
                }

                span{
                    color: #004FFF;
                }

                .levelTop {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    width: 100%;
                    max-width: 160px;

                    .levelTopLinguage {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .boxLanguage {
                            display: flex;
                            width: 100%;
                            justify-content: space-between;
                            flex-direction: column;

                            h5{
                                padding: 0;
                                margin: 0;
                                color: #87868F;
                            }

                            .language {
                                display: flex;
                                margin: 7px 0 13px 0;
                                align-items: center;

                                img {
                                    margin: 0 8px 0 0;
                                }

                                h5{
                                    font-size: 18px;
                                    color: #87868F;
                                    margin: 0;
                                    padding: 0;
                                    font-family: 'Quicksand',sans-serif;
                                    font-weight: 100;
                                }
                            }
                        }
                    }

                    .columLevel {
                        justify-content: flex-end;
                        display: flex;
                        width: 100%;

                        h5 {
                            text-align: right;
                            padding: 0;
                            margin: 0;
                            color: #87868F;
                        }
                    }

                }

                .another-grades{
                  align-items: center;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }

                .grades {
                    display: flex;
                    flex-direction: row;
                    align-items: center;


                    h6 {
                        margin:  0 10px 0 0;
                        color: #87868F;
                        font-size: 15px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: bold;
                    }

                    h5{
                        padding: 0;
                        margin: 0;
                        color: #87868F;
                        font-size: 14px;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: normal;
                        font-weight: bold;
                        text-align: center;

                        span {
                            color: #004FFF;
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        /** Notifications **/
        .infoNotification {
            width: 100%;

            h2 {
                color: #403F4C;
                font-size: 18px;
                margin: 40px 0 0 52px;
                font-weight: 100;
                font-family: 'Quicksand', sans-serif;
            }

            ul {
                margin: 40px 0 0 57px;
                display: flex;
                width: 88%;
                flex-direction: column;

            li {
                    display: flex;
                    align-items: center;
                    padding: 0;
                    margin: 0;
                    height: 50px;

                    span {
                        width: 175px;
                        color: #403F4C;
                        font-size: 16px;
                        font-family: 'Quicksand', sans-serif;
                    }

                }
            }
        }

        /** Manage Available Hours **/
        .topManage {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            margin: 15px 25px 0 0;
            align-items: center;

            h2 {
                font-size: 18px;
                color: #403F4C;
                font-weight: normal;
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 14px;
                font-weight: bold;
                border-radius: 26px;
                width: auto;
                height: 38px;
                margin-top: 5px;
                padding: 12px;
                cursor: pointer;
                font-family: 'Work Sans', sans-serif;
            }
        }

        .manage {
            display: flex;
            width: 100%;
            justify-content: start;
            flex-direction: column;

            .day {
                display: flex;
                align-items: center;
                flex-direction: row;
                margin: 10px 0 10px 0;
            }

            h2 {
                font-size: 14px;
                color: #004FFF;
                font-weight: 500;
                font-family: 'Work Sans', sans-serif;
            }

            p{
                color: #C5C5C5
            }

            button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 11px;
                font-weight: bold;
                border-radius: 26px;
                width: 44px;
                height: 22px;
                margin: 5px 0 0 16px;
                cursor: pointer;
            }

            ul {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                list-style: none;
                padding: 0;

                .configDay {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row;
                    margin: 0 30px 0 0;
                }

                li {
                    font-size: 14px;
                    color: #403F4C;
                    padding: 0 5px 0 0;

                span {
                        color: red;
                        font-size: 12px;
                    }

                    button {
                        background-color: white;
                        width: 55px;
                        cursor: pointer;
                        color: red;
                        font-size: 12px;
                        margin: 0;
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                    }

                }
            }

        }

        /** Edit **/
        .selectDays{
            margin: 35px 0 0 28px;

            h2 {
                color: #403F4C;
                font-size: 28px;
                margin: 0;
                font-family: 'Quicksand',sans-serif;
                font-weight: 100;
            }

            h3 {
                color: #403F4C;
                font-size: 12px;
                margin: 0;
                max-width: 72%;
            }

            h4 {
                color: #403F4C;
                font-size: 14px;
                margin: 25px 0 0 0;
            }

            ul {
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                justify-content: start;
                list-style: none;
                padding: 0;

                li {
                    margin: 0 10px 0 0;
                    padding: 5px 0 0 0;

                    span{
                        font-size: 12px;
                        color: #403F4C;
                        margin-top: 5px;
                        font-family: 'Quicksand', sans-serif;
                    }

                    button {
                        background-color: #fff;
                        border: 1px solid #B2B2B7;
                        color: #B2B2B7;
                        font-size: 14px;
                        border-radius: 26px;
                        width: 76px;
                        height: 28px;
                        margin-top: 0;
                        cursor: pointer;
                    }

                    button.active {
                        background-color: #004FFF;
                        color: #fff;
                        border: #004FFF;
                    }
                }
            }

            .time{
                ul {
                    list-style: none;
                    margin-left: 24px;

                    li {
                        display: flex;
                        flex-direction: column;
                    }
                }

                select {
                    background-color: #004FFF;
                    color: #fff;
                    border-radius: 26px;
                    border: 0;
                    width: 114px;
                    height: 28px;
                    padding-left: 10px;
                    font-family: 'Work Sans', sans-serif;
                    font-size: 14px;
                    margin-top: 5px;
                }
            }

            .addSlot{
                button {
                    background-color: #fff;
                    border: 1px solid #B2B2B7;
                    color: #B2B2B7;
                    font-size: 14px;
                    border-radius: 26px;
                    width: 100%;
                    height: 28px;
                    margin: 20px 0 36px 24px;
                    cursor: pointer;
                    font-family: 'Work Sans',sans-serif;
                    font-weight: 500;
                    padding: 0 10px 0 10px;
                }
            }

            .buttons {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                margin: 25px;
                padding: 0 15px 0 15px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

                button {
                    background-color: transparent;
                    border: 1px solid #787780;
                    color: #403F4C;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: auto;
                    height: 28px;
                    margin-top: 9px;
                    cursor: pointer;

                    .fa{
                        margin-right: 5px;
                    }

                    &:last-child {
                        background-color: #004FFF;
                        border: none;
                        color: #fff;
                        font-weight: bold;
                        font-size: 11px;
                        border-radius: 26px;
                        padding: 10px 20px;
                        height: 38px;
                        margin-left: 15px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                }
            }
        }

        .pagamento{
            display: flex;
            align-items: center;
            gap: 40px;

            .plans{
              min-width: 150px;
              .payment{
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                h2{
                  font-size: 16px !important;
                  color: #403f4c;
                }
                h3{
                  text-transform: capitalize;
                  width: 100%;
                }
              }
            }
        }

        .inputManage{
            border-color: #B2B2B7 !important;
        }

    }
`;
